export default __webpack_public_path__ + "static/media/Square Shield of the Ziggurat.f8fcce05.jpg";